import { render, staticRenderFns } from "./growup.vue?vue&type=template&id=47267c24&scoped=true&"
import script from "./growup.vue?vue&type=script&lang=js&"
export * from "./growup.vue?vue&type=script&lang=js&"
import style0 from "./growup.vue?vue&type=style&index=0&id=47267c24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47267c24",
  null
  
)

export default component.exports